import { useMutation } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { PostClinicPartnerInvitationResponse } from "../schemas/invitations";

export const usePostResendClinicPartnerInvitation = () => {
  const client = useApiClient();

  return useMutation<PostClinicPartnerInvitationResponse, Error, number>({
    mutationFn: args => client.postResendClinicPartnerInvitation(args),
  });
};
